import './styles.scss';

export const FilterButton = ({ label, icon, onChangeFilter, isActive, id, showCheckbox, defaultOrientation }) => {
  return (
    <button
      className={`filter-button ${isActive ? 'active' : ''}`}
      onClick={onChangeFilter}
      data-id={id}
      data-orientation={defaultOrientation ? JSON.stringify(defaultOrientation) : undefined}
    >
      <span className="filter-button-content">
        {icon}
        <span className="filter-button-label">{label}</span>
      </span>
      {showCheckbox && (
        <span className={`filter-checkbox ${isActive ? 'checked' : ''}`}>
          {isActive && (
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M2 6L5 9L10 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          )}
        </span>
      )}
    </button>
  );
};
